/** AllItemsTab — "All Items" tab wrapper. Props: data */
import React from 'react';
import AllItemsTable from './AllItemsTable';

export default function AllItemsTab({ data }) {
  return (
    <div className="sq__pane">
      <div className="sq__card">
        <div className="sq__card-title">All Items This Period</div>
        <AllItemsTable categories={data.categories} />
      </div>
    </div>
  );
}
